import React from 'react';
import { injectIntl } from 'react-intl';
import { getSoundPropsById, isNotEmpty } from '../../lib/ep.js';

import GameContainer from './GameContainer.js';

import MatchCanvas from '../games/MatchCanvas_new.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	return null;
};

const MatchItClient = ({ stage, ...props }) => {
	const sound_fx = {
		move:new Howl({ ...getSoundPropsById('card_flip') }),
		error:new Howl({ ...getSoundPropsById('error_backflip') }),
		found:new Howl({ ...getSoundPropsById('success') }),
		success:new Howl({ ...getSoundPropsById('applause') }),
		fail:new Howl({ ...getSoundPropsById('fail') }),
	};

	const canvas_images = () => {
		const images = [];

		if(stage.Stage?.matchit_images) {
			stage.Stage.matchit_images.map((pair) => {
				if(!pair[0] || !pair[1])return null;
				images.push({
					id:pair[0].image,
					name:pair[0].image,
					group:pair[0].name,
					url:pair[0].full,
					index:0,
					fit:'contain'
				})
				
				images.push({
					id:pair[1].image,
					name:pair[1].image,
					group:pair[1].name,
					url:pair[1].full,
					index:1,
					fit:'contain'
				})
			});
		}
		
		if(isNotEmpty(stage.Stage,'matchit_backflip1_image')) {
			images.push({
				id:'matchit_backflip1_image',
				name:stage.Stage.matchit_backflip1_image,
				url:stage.Stage.full_matchit_backflip1_image,
				fit:'contain'
			})
		}

		if(isNotEmpty(stage.Stage,'matchit_backflip2_image')) {
			images.push({
				id:'matchit_backflip2_image',
				name:stage.Stage.matchit_backflip2_image,
				url:stage.Stage.full_matchit_backflip2_image,
				fit:'contain'
			})
		}

		if(isNotEmpty(stage.Stage, 'bg_image')) {
			images.push({
				id:'bg_image',
				name:stage.Stage.bg_image,
				url:stage.Stage.full_bg_image,
				fit:'cover'
			});
		}

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			stage.Stage.matchit_images,
			stage.Stage.matchit_backflip1_image,
			stage.Stage.matchit_backflip2_image,
			stage.Stage.bg_image,
		],
	});

	const game_key = `game_${stage.Stage?.matchit_distribution_mode ?? 'separation'}`;

	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			key={game_key}
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			game_type="matchit"
			display_audio_controls={true}
			auto_start_timer={false}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			sound_fx={sound_fx}
		>
			{((stage.Stage?.matchit_images ?? []).length > 2) ? (
				<MatchCanvas
					indexed_images={state.images}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Upload at least 3 different pairs of matching images to create the game"
					img_recommendations={{
						w:200,
						h:200,
					}}
				/>
			)}
		</GameContainer>
	)
};

export default injectIntl(MatchItClient);